module.exports = __webpack_public_path__ + "media/site/images/svg/footer-fanpage-circle-ed1eedd0a034a89a9daade1348ed0d5c.svg";